import { Edit } from '@mui/icons-material';
import {Checkbox, FormControlLabel, Grid, Paper, Skeleton, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Restore as RestoreIcon, Visibility as VisibilityIcon, Sync as SyncIcon } from '@mui/icons-material';
import LesseeCRU from './lesseeCRU';
import SyncConfirmModal from './SyncConfirmModal';
import { useParams } from 'react-router-dom';
import { globalGetService, globalPutService } from '../../../../utils/globalApiServices';
import { getLesseeApi, putLesseeApi } from '../apiServices';
import { checkApiStatus } from '../../../../utils';
import { PermissionWrapper } from '../../../../wrappers';
import { PageLoader } from '../../../../shared_elements';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import { trackActivity } from '../../../../utils/mixpanel';
import { enqueueSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { fetchLeaseBasicDetails } from '../../../../shared_elements/actionCreators';

const Lessee = () => {
  const dispatch = useDispatch();
  const { leaseSlug } = useParams();
  const params = { leaseSlug: leaseSlug };
  const [editLessee, setEditLessee] = useState({ mode: "", modal: false, data: {} });
  const [syncLessee, setSyncLessee] = useState({ mode: "", modal: false, data: {} });
  const [lesseeData, setLesseeData] = useState(null);
  const [isLoading,setLoading]=useState(false);
  const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
  useEffect(() => {
    getLesseeData();
  }, []);

  const getLesseeData = () => {
    setLoading(true);
    globalGetService(getLesseeApi(params?.leaseSlug))
      .then(response => {
        if (checkApiStatus(response)) {
          setLesseeData(response?.data?.data || {});
          setLoading(false);
        }
      });
  }
  const handleSyncFunction = () => {
    setLoading(true);
    globalPutService(putLesseeApi(leaseSlug, { 'cross_feature_check': 'lease_details' }))
      .then(async (response) => {
        if (checkApiStatus(response)) {
          dispatch(fetchLeaseBasicDetails({ slug: leaseSlug, setLoading }));
          getLesseeData();
          setSyncLessee({ mode: "", modal: false, data: {} })
          enqueueSnackbar('Lessee info synchronized successfully.', { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Edited', { page_title: `Lessor info synchronized`, success_msg: 'Lessor info synchronized successfully.', leaseSlug: leaseSlug, response: response?.data })
        } else {
          enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
        }
      })
  }
const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Headlines`, page_type: page_type, })
  }

  const isSameOperator = lesseeData?.same_operator_lessee === 1;

  return (
    <>
      {isLoading ? (
        <Paper sx={{ padding: 1, backgroundColor: "#FAFAFA", minHeight: "590px", width: '100%', boxShadow: "0px 0px 0px 1px #BBBBBB", margin: "1px", }} >
          <Grid sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} mb={2} >
            <Skeleton width={120} height={30} />
          </Grid>
          <Grid container spacing={2}>
            {[...Array(9)].map((_, i) => (
              <Grid key={i} size={{ md: 12, xs: 12 }}>
                <Skeleton variant="rectangular" height={40} sx={{ borderRadius: "8px" }} />
              </Grid>
            ))}
          </Grid>
        </Paper>
      ) : <>
      <Paper className="headline-readonly-fields" sx={{ padding: 1, backgroundColor: '#FAFAFA', minHeight: "490px", width: '100%', boxShadow: "0px 0px 0px 1px #BBBBBB",     margin: '1px' }}>
        <Grid sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }} mb={2}>
          <Typography color="primary"  fontSize='18px'>Lessee</Typography>
          <Grid>
            <Tooltip title="Revision History">
              <RestoreIcon fontSize="small" className="revision-history" onClick={() => { setRevisionHistory({ modal: true, data: { slug: leaseSlug }, mode: 'view' }); handleItemClicked('Lessee RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} color="primary" />
            </Tooltip>
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['U'] }}>
                  <Tooltip title="Sync"> <SyncIcon fontSize="small" className="revision-history" onClick={() => { setSyncLessee({ modal: true }); handleItemClicked('Lessee SyncIcon') }} sx={{ cursor: 'pointer' }} color="primary" /> </Tooltip>
                </PermissionWrapper>
            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['R'] }}>
              <Tooltip title="View" arrow><VisibilityIcon sx={{ cursor: 'pointer' }} fontSize='small' color='primary' onClick={() => { setEditLessee({ modal: true, mode: "view", data: lesseeData }); handleItemClicked('ViewIcon') }} /></Tooltip>
            </PermissionWrapper>
            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "headlines", operationType: ['U'] }}>
              <Tooltip title="Edit">
                <Edit onClick={() => { setEditLessee({ modal: true, mode: "edit", data: lesseeData }); handleItemClicked('Lessee EditIcon') }} fontSize="small" color="primary" sx={{ cursor: 'pointer' }} />
              </Tooltip>
            </PermissionWrapper>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Name"
              varient="outlined"
              disabled={true}
              size="small"
              value={lesseeData?.lessee?.name || ""}
              margin="normal"
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          {!isSameOperator ?
          <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                label="Operator"
                varient="outlined"
                disabled={true}
                size="small"
                value={lesseeData?.operator?.name || ""}
                margin="normal"
                slotProps={{ inputLabel: { shrink: true } }}
                fullWidth />
          </Grid> :null}
          {/* <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Habitual Base"
              varient="outlined"
              disabled={true}
              size='small'
              margin='normal'
              value={lesseeData?.habitual_base}
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>} */}
          <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                label="Jurisdiction"
                varient="outlined"
                disabled={true}
                size='small'
                margin='normal'
                value={lesseeData?.lessee_jurisdiction || ""}
                slotProps={{ inputLabel: { shrink: true } }}
                fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Habitual Base"
              varient="outlined"
              disabled={true}
              size='small'
              margin='normal'
              value={lesseeData?.habitual_base}
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Contact (Email)"
              varient="outlined"
              disabled={true} size='small'
              margin='normal'
              value={lesseeData?.lessee_contact_email || ""}
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Contact (Phone)"
              varient="outlined"
              disabled={true} size='small'
              margin='normal'
              value={lesseeData?.lessee_phone_number || ""}
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Contact (Fax)"
              varient="outlined"
              disabled={true} size='small'
              margin='normal'
              value={lesseeData?.lessee_contact_fax_number || ""}
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          {/* <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Contact Address"
              varient="outlined"
              disabled={true}
              size='small'
              margin='normal'
              value={lesseeData?.lessee_contact_address}
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid> */}
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Country of Incorporation"
              value={lesseeData?.lessee_country_of_incorporation || ""}
              varient="outlined"
              size='small'
              disabled={true}
              margin='normal'
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            <TextField
              label="Attention To"
              value={lesseeData?.lessee?.atten_to || ""}
              varient="outlined"
              size='small'
              margin='normal'
              disabled={true}
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth />
          </Grid>
          <Grid size={{ md: 12, xs: 12 }}>
            {/* <TextField
              label="Contractual Notice Address"
              variant='outlined'
              disabled={true}
              size='small'
              margin='normal'
              value={lesseeData?.contractual_notice_address}
              slotProps={{ inputLabel: { shrink: true } }}
              fullWidth /> */}
            <FormControlLabel disabled label="Operator Same As Lessee" control={<Checkbox checked={lesseeData?.same_operator_lessee === 1} />} ></FormControlLabel>
          </Grid>
        </Grid> 
      </Paper></>}
      {
        editLessee?.modal ? <LesseeCRU
          editLessee={editLessee}
          params={params?.leaseSlug}
          modeType={editLessee.mode}
          getResponseBack={getLesseeData}
          onToggleModal={() => setEditLessee({ ...editLessee, modal: false, data: null })}
        /> : null
      }
      {revisionHistory?.modal ?
        <RevisionHistory
          moduleName={"lease"}
          revisionHistory={revisionHistory}
          onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
          section_type='lessee'
        /> : null
      }
      {syncLessee?.modal ?
        <SyncConfirmModal
          sync={syncLessee}
          onToggleModal={() => setSyncLessee({ modal: false, mode: '', data: null })}
          sectionName='Lessee'
          getResponseBack={handleSyncFunction}
          isLoading={isLoading}
        /> : null
      }
    </>
  )
}

export default Lessee;